import { z } from 'zod'

const errorData = z.object({
  view_message: z.string()
})

const errorWithViewMessageSchema = z.object({
  data: errorData
})

type ErrorWithViewMessage = z.infer<typeof errorWithViewMessageSchema>

export const isErrorWithViewMessage = (
  obj: unknown
): obj is ErrorWithViewMessage =>
  errorWithViewMessageSchema.safeParse(obj).success
